export enum UserRoleIds {
  admin = 'admin',
  agent = 'agent',
  customer = 'customer',
  partner = 'partner',
  systemAgent = 'systemAgent',
}
